import { render, staticRenderFns } from "./LastUpdates.vue?vue&type=template&id=436a9d3c&scoped=true&"
import script from "./LastUpdates.vue?vue&type=script&lang=js&"
export * from "./LastUpdates.vue?vue&type=script&lang=js&"
import style0 from "./LastUpdates.vue?vue&type=style&index=0&id=436a9d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a9d3c",
  null
  
)

export default component.exports